import { ensureDir, testAccess } from '@/utils/fs/fs-extra.utils';
import { ElectronApi } from '../electron.api';
import { getImageBase64 } from '@/utils/fs/image.utils';

export class WatchfacePreview {
  // 预览图目录
  private PreviewPath: string;
  // 主题预览图目录
  constructor(PreviewPath: string) {
    this.PreviewPath = PreviewPath;
  }

  /**
   * 读取preview目录下的预览图，返回base64
   * @param key 预览图名称:相对于preview目录
   * @returns
   */
  async getPreviewImage(key: string) {
    const path = ElectronApi.path;
    const fs = ElectronApi.fs;
    if (!path || !fs) return;
    const previewPath = this.PreviewPath;
    await ensureDir(previewPath);
    const imagePath = path.join(previewPath, key);
    if (await testAccess(imagePath)) {
      const val = await getImageBase64(imagePath);
      return val ?? '';
    }
  }

  async deletePreviewImage(key: string) {
    const path = ElectronApi.path;
    const fs = ElectronApi.fs;
    if (!path || !fs) return;
    const previewPath = this.PreviewPath;
    const imagePath = path.join(previewPath, key);
    if (await testAccess(imagePath)) await fs.promises.rm(imagePath);
  }

  async writeImage(key: string, dataUrl: string) {
    const path = ElectronApi.path;
    const fs = ElectronApi.fs;
    if (!path || !fs) return;
    // 写入图片
    const to = path.join(this.PreviewPath, key);
    await fs.promises.writeFile(to, dataUrl.split(',')[1] ?? '', 'base64');
  }

  getAbsolutePath(key: string) {
    const path = ElectronApi.path;
    const previewPath = this.PreviewPath;
    return path?.join(previewPath, key);
  }
}
